<template>
  <span class="main-images-addon">
    <span class="addon-head">
      <span class="badge-new">new!</span>
      <span class="title">AI改图已上线，立即体验！</span>
      <el-popover
        trigger="hover"
        placement="right-start"
        width="400"
        popper-class="ai-doc-popover"
      >
        <div class="addon-body">
          <div class="step-card">
            <div class="step-title">1. 上传图片后，即可操作AI改图，如下：</div>
            <div class="step-imgs">
              <div class="img-sample">
                <img :src="AIEdit_1" alt="" class="img"/>
              </div>
            </div>
          </div>
          <div class="step-card">
            <div class="step-title">
              2. 点击AI改图后，即可进入工作台，可实现模特换衣、姿势裂变、场景裂变、AI模特、白底图等多种电商图片换改场景诉求
            </div>
            <div class="workspace-shot">
              <img :src="AIEdit_2" alt="" class="img"/>
            </div>
          </div>
        </div>
        <el-link slot="reference" type="primary" class="doc-link">使用说明</el-link>
      </el-popover>
    </span>
  </span>
  
</template>

<script>
import AIEdit_1 from '@/assets/images/AIEdit-1.png'
import AIEdit_2 from '@/assets/images/AIEdit-2.png'
export default {
  name: 'MainImagesAddon',
  props: {},
  data() {
    return {
      AIEdit_1,
      AIEdit_2
    }
  }
};
</script>

<style scoped>
.main-images-addon {
  margin-top: 8px;
}
.badge-new {
  margin-left: 8px;
  background: #ff3b30;
  color: #fff;
  border-radius: 8px;
  padding: 2px 6px;
  font-size: 12px;
  margin-right: 8px;
}
.title {
  color: #333;
  font-size: 14px;
}
.doc-link {
  margin-left: auto;
}
.ai-doc-popover .addon-body { border: 1px solid #d7e7ff; background: #f5fbff; border-radius: 8px; }
.addon-body {
  border: 1px solid #d7e7ff;
  background: #f5fbff;
  padding: 10px;
  border-radius: 8px;
}
.step-card { 
  margin-bottom: 12px;
}
.step-title { 
  color: #333; 
  font-size: 14px; 
  margin-bottom: 8px;
}
.step-imgs { 
  display: flex; 
  gap: 12px; 
}
.img-sample { 
  position: relative; 
  width: 160px; 
  /* height: 120px;  */
  border: 1px solid #e5e5e5; 
  border-radius: 6px; 
  background: #fff; 
  display: flex; 
  align-items: center; 
  justify-content: center; 
}
.img-sample.placeholder { opacity: 0.6; }
.img { 
  width: 100%;
  /* height: 100%; */
}
.ai-btn { 
  position: absolute; 
  bottom: 8px; 
  left: 8px; 
  background: rgba(0,0,0,0.6); 
  color: #fff; 
  padding: 4px 10px; 
  border-radius: 4px; 
  font-size: 12px; 
}
.workspace-shot { 
  /* height: 160px;  */
  border: 1px solid #e5e5e5; 
  background: #fff; 
  border-radius: 6px; 
}
</style>